module.exports = __webpack_public_path__ + "media/pk_join.9cda863e.mp3";